import React, { useEffect, useState } from "react";
import { Tree, Card, Row, Col, Divider, Empty, Modal } from "antd";
import _ from "lodash";

/**
 * Actions
 */
import { allFormsOfSavedObjectsWithFields } from "auth/actions/objActions";
import { filterTree, renderTreeNodes } from "./utils.js";
import { LockOutlined } from "@ant-design/icons";

export default function TreeTransfer({ single = false, ...props }) {
  const [clean, setClean] = useState([]);
  const [data, setData] = useState([]);
  const [checkedNodes, setCheckedNodes] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);

  useEffect(() => {
    onGet();
  }, [props.refresh, props.selected, props.needUpdated]);

  const onGet = () => {
    allFormsOfSavedObjectsWithFields().then((items) => {
      let allResults = items.message || [];
      if (props.lookup) {
        // Para cada objeto, filtrar a lista fields para remover objetos cujo fieldtype é "refLookup" ou "label"
        allResults = allResults.map((obj) => {
          return {
            ...obj,
            fields: obj.fields.filter(
              (field) => field.fieldtype !== "refLookup" && field.fieldtype !== "label"
            ),
          };
        });
      }
      setClean(allResults);
      // organiza os campos
      var filtered = allResults
        .map((obj) => ({
          title: obj.name.replace("obj_", ""),
          key: obj.name,
          children: obj.fields.map((field) => ({
            key: field._id,
            title: field.field,
          })),
          children: obj.fields.map((field) => {
            return {
              key: field._id, 
              title: field.field
            }
          })
        }))
        .filter((obj) => _.size(obj.children) > 0);
      // carrega os campos
      setData(filtered);
      // verifica se existe campos selecionado
      if (props.selected) {
        var selectedFrm = [],
          selectedFld = [],
          selectedOpt = [];
        // forms
        _.at(
          _.keyBy(filtered, "title"),
          allResults
            .map((form) => ({
              form: form.name,
              fields: _.compact(
                _.at(
                  _.keyBy(form.fields, "_id"),
                  _.map(props.selected, "field")
                )
              ),
            }))
            .filter((obj) => obj.fields.length > 0)
            .map((obj) => obj.form.replace("obj_", ""))
        ).map((obj) => selectedFrm.push(obj.key));
        // campos e opcoes
        _.flattenDeep(
          filtered.map((obj) =>
            _.compact(
              _.at(_.keyBy(obj.children, "key"), _.map(props.selected, "field"))
            )
          )
        ).forEach((field) => {
          selectedFld.push(field.key);
        });
        // seleciona as opcoes
        const filteredTree = filterTree(selectedFrm, selectedFld, filtered);

        const result = [];
        filteredTree.forEach((node) => {
          node.children.forEach((child) => {
            result.push({
              form: `obj_${node.title}`,
              field: child.key,
              fieldName: child.title
            });
          });
        });
        props.form.setFieldsValue({ refOpt: result });
        props.onChange(result);
        setCheckedNodes(filteredTree);
        setSelectedFields(selectedFld);
        if (props.onReady) {
          props.onReady();
        }
      }
    });
  };

  const onCheck = (fields, info) => {
    // Se o modo de seleção única estiver ativado e houver mais de um campo selecionado, retorne
    if (single && fields.length > 1) {
      Modal.warning({
        title: "Campo já selecionado",
        content: "Você já possui um campo selecionado para busca. Remova o mesmo para selecionar outro."
      });
      return;
    }

    const filteredTree = filterTree(
        fields,
        info.halfCheckedKeys,
        props.selected ? (info.data ? info.data : data) : data
      ),
      nodes = filteredTree,
      result = [];
    nodes.forEach((node) => {
      node.children.forEach((child) => {
        result.push({
          form: `obj_${node.title}`,
          field: child.key,
          fieldName: child.title
        });
      });
    });

    // seleciona as opções
    props.form.setFieldsValue({ refOpt: result });
    props.onChange(result);
    setCheckedNodes(filteredTree);
    setSelectedFields(fields);
  };

  return (
    <div>
      <div>
        <Card>
          <Tree
            checkable
            defaultExpandAll
            checkedKeys={selectedFields}
            onCheck={onCheck}
            height={200}
            disabled={props.disabled ? true : false}
          >
            {renderTreeNodes(data)}
          </Tree>
        </Card>
      </div>
    </div>
  );
}
